"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var MiddlewareStack =
/** @class */
function () {
  function MiddlewareStack() {
    this.absoluteEntries = [];
    this.relativeEntries = [];
    this.entriesNameMap = {};
  }

  MiddlewareStack.prototype.add = function (middleware, options) {
    if (options === void 0) {
      options = {};
    }

    var name = options.name,
        _a = options.step,
        step = _a === void 0 ? "initialize" : _a,
        tags = options.tags,
        _b = options.priority,
        priority = _b === void 0 ? "normal" : _b;
    var entry = {
      name: name,
      step: step,
      tags: tags,
      priority: priority,
      middleware: middleware
    };

    if (name) {
      if (Object.prototype.hasOwnProperty.call(this.entriesNameMap, name)) {
        throw new Error("Duplicated middleware name '" + name + "'");
      }

      this.entriesNameMap[name] = entry;
    }

    this.absoluteEntries.push(entry);
  };

  MiddlewareStack.prototype.addRelativeTo = function (middleware, options) {
    var _a = options.step,
        step = _a === void 0 ? "initialize" : _a,
        name = options.name,
        tags = options.tags,
        relation = options.relation,
        toMiddleware = options.toMiddleware;
    var entry = {
      middleware: middleware,
      step: step,
      name: name,
      tags: tags,
      next: relation === "before" ? toMiddleware : undefined,
      prev: relation === "after" ? toMiddleware : undefined
    };

    if (name) {
      if (Object.prototype.hasOwnProperty.call(this.entriesNameMap, name)) {
        throw new Error("Duplicated middleware name '" + name + "'");
      }

      this.entriesNameMap[name] = entry;
    }

    this.relativeEntries.push(entry);
  };

  MiddlewareStack.prototype.sort = function (entries) {
    //reverse before sorting so that middleware of same step will execute in
    //the order of being added
    return entries.sort(function (a, b) {
      return stepWeights[b.step] - stepWeights[a.step] || priorityWeights[b.priority || "normal"] - priorityWeights[a.priority || "normal"];
    });
  };

  MiddlewareStack.prototype.clone = function () {
    var _a, _b;

    var clone = new MiddlewareStack();

    (_a = clone.absoluteEntries).push.apply(_a, this.absoluteEntries);

    (_b = clone.relativeEntries).push.apply(_b, this.relativeEntries);

    clone.entriesNameMap = tslib_1.__assign({}, this.entriesNameMap);
    return clone;
  };

  MiddlewareStack.prototype.concat = function (from) {
    var _a, _b;

    var clone = new MiddlewareStack();
    clone.entriesNameMap = tslib_1.__assign({}, this.entriesNameMap); // IMiddlewareStack interface doesn't contain private members variables
    // like `entriesNameMap`, but in fact the function expects `MiddlewareStack`
    // class instance. So here we cast it.

    var _from = from;

    for (var name in _from.entriesNameMap) {
      if (clone.entriesNameMap[name]) {
        throw new Error("Duplicated middleware name '" + name + "'");
      }

      clone.entriesNameMap[name] = _from.entriesNameMap[name];
    }

    (_a = clone.absoluteEntries).push.apply(_a, tslib_1.__spreadArrays(this.absoluteEntries, _from.absoluteEntries));

    (_b = clone.relativeEntries).push.apply(_b, tslib_1.__spreadArrays(this.relativeEntries, _from.relativeEntries));

    return clone;
  };

  MiddlewareStack.prototype.remove = function (toRemove) {
    if (typeof toRemove === "string") return this.removeByName(toRemove);else return this.removeByReference(toRemove);
  };

  MiddlewareStack.prototype.removeByName = function (toRemove) {
    for (var i = this.absoluteEntries.length - 1; i >= 0; i--) {
      if (this.absoluteEntries[i].name && this.absoluteEntries[i].name === toRemove) {
        this.absoluteEntries.splice(i, 1);
        delete this.entriesNameMap[toRemove];
        return true;
      }
    }

    for (var i = this.relativeEntries.length - 1; i >= 0; i--) {
      if (this.relativeEntries[i].name && this.relativeEntries[i].name === toRemove) {
        this.relativeEntries.splice(i, 1);
        delete this.entriesNameMap[toRemove];
        return true;
      }
    }

    return false;
  };

  MiddlewareStack.prototype.removeByReference = function (toRemove) {
    for (var i = this.absoluteEntries.length - 1; i >= 0; i--) {
      if (this.absoluteEntries[i].middleware === toRemove) {
        var name = this.absoluteEntries[i].name;
        if (name) delete this.entriesNameMap[name];
        this.absoluteEntries.splice(i, 1);
        return true;
      }
    }

    for (var i = this.relativeEntries.length - 1; i >= 0; i--) {
      if (this.relativeEntries[i].middleware === toRemove) {
        var name = this.relativeEntries[i].name;
        if (name) delete this.entriesNameMap[name];
        this.relativeEntries.splice(i, 1);
        return true;
      }
    }

    return false;
  };

  MiddlewareStack.prototype.removeByTag = function (toRemove) {
    var removed = false;

    for (var i = this.absoluteEntries.length - 1; i >= 0; i--) {
      var _a = this.absoluteEntries[i],
          tags = _a.tags,
          name = _a.name;

      if (tags && tags.indexOf(toRemove) > -1) {
        this.absoluteEntries.splice(i, 1);
        if (name) delete this.entriesNameMap[name];
        removed = true;
      }
    }

    for (var i = this.relativeEntries.length - 1; i >= 0; i--) {
      var _b = this.relativeEntries[i],
          tags = _b.tags,
          name = _b.name;

      if (tags && tags.indexOf(toRemove) > -1) {
        this.relativeEntries.splice(i, 1);
        if (name) delete this.entriesNameMap[name];
        removed = true;
      }
    }

    return removed;
  };

  MiddlewareStack.prototype.use = function (plugin) {
    plugin.applyToStack(this);
  };
  /**
   * Resolve relative middleware entries to multiple double linked lists
   * depicting the relative location of middleware. Only middleware that have
   * direct or transitive relation will form a linked list.
   *
   * This function normalizes relative middleware into 2 categories of linked
   * lists. (1) linked list that have absolute-located middleware on one end.
   * These middleware will be resolved accordingly before or after the absolute-
   * located middleware. (2) Linked list that have no absolute-located middleware
   * on any end. They will be resolved to corresponding step with normal priority
   *
   * The 2 types of linked list will return as a tuple
   */


  MiddlewareStack.prototype.normalizeRelativeEntries = function () {
    var absoluteMiddlewareNamesMap = this.absoluteEntries.filter(function (entry) {
      return entry.name;
    }).reduce(function (accumulator, entry) {
      accumulator[entry.name] = entry;
      return accumulator;
    }, {});
    var normalized = this.relativeEntries.map(function (entry) {
      return tslib_1.__assign(tslib_1.__assign({}, entry), {
        priority: null,
        next: undefined,
        prev: undefined
      });
    });
    var relativeMiddlewareNamesMap = normalized.filter(function (entry) {
      return entry.name;
    }).reduce(function (accumulator, entry) {
      accumulator[entry.name] = entry;
      return accumulator;
    }, {});
    var anchors = {};

    for (var i = 0; i < this.relativeEntries.length; i++) {
      var _a = this.relativeEntries[i],
          prev = _a.prev,
          next = _a.next;
      var resolvedCurr = normalized[i]; //either prev or next is set

      if (prev) {
        if (absoluteMiddlewareNamesMap[prev] && absoluteMiddlewareNamesMap[prev].step === resolvedCurr.step) {
          if (!anchors[prev]) anchors[prev] = {};
          resolvedCurr.next = anchors[prev].next;
          if (anchors[prev].next) anchors[prev].next.prev = resolvedCurr;
          anchors[prev].next = resolvedCurr;
        } else if (relativeMiddlewareNamesMap[prev] && relativeMiddlewareNamesMap[prev].step === resolvedCurr.step) {
          var resolvedPrev = relativeMiddlewareNamesMap[prev];
          if (resolvedPrev.next === resolvedCurr) continue;
          resolvedCurr.next = resolvedPrev.next;
          resolvedPrev.next = resolvedCurr;
          if (resolvedCurr.next) resolvedCurr.next.prev = resolvedCurr;
          resolvedCurr.prev = resolvedPrev;
        }
      } else if (next) {
        if (absoluteMiddlewareNamesMap[next] && absoluteMiddlewareNamesMap[next].step === resolvedCurr.step) {
          if (!anchors[next]) anchors[next] = {};
          resolvedCurr.prev = anchors[next].prev;
          if (anchors[next].prev) anchors[next].prev.next = resolvedCurr;
          anchors[next].prev = resolvedCurr;
        } else if (relativeMiddlewareNamesMap[next] && relativeMiddlewareNamesMap[next].step === resolvedCurr.step) {
          var resolvedNext = relativeMiddlewareNamesMap[next];
          if (resolvedNext.prev === resolvedCurr) continue;
          resolvedCurr.prev = resolvedNext.prev;
          resolvedNext.prev = resolvedCurr;
          if (resolvedCurr.prev) resolvedCurr.prev.next = resolvedCurr;
          resolvedCurr.next = resolvedNext;
        }
      }
    } // get the head of the relative middleware linked list that have
    // no transitive relation to absolute middleware.


    var orphanedRelativeEntries = [];
    var visited = new WeakSet();

    for (var _i = 0, _b = Object.keys(anchors); _i < _b.length; _i++) {
      var anchorName = _b[_i];
      var _c = anchors[anchorName],
          prev = _c.prev,
          next = _c.next;

      while (prev) {
        visited.add(prev);
        prev = prev.prev;
      }

      while (next) {
        visited.add(next);
        next = next.next;
      }
    }

    for (var i = 0; i < normalized.length; i++) {
      var entry = normalized[i];
      if (visited.has(entry)) continue;
      if (!entry.prev) orphanedRelativeEntries.push(entry);

      while (entry && !visited.has(entry)) {
        visited.add(entry);
        entry = entry.next;
      }
    }

    return [orphanedRelativeEntries, anchors];
  };
  /**
   * Get a final list of middleware in the order of being executed in the resolved handler.
   * If relative entries list is not empty, those entries will be added to final middleware
   * list with rules below:
   * 1. if `toMiddleware` exists in the specific `step`, the middleware will be inserted before
   *     or after the specified `toMiddleware`
   * 2. if `toMiddleware` doesn't exist in the specific `step`, the middleware will be appended
   *     to specific `step` with priority of `normal`
   */


  MiddlewareStack.prototype.getMiddlewareList = function () {
    var middlewareList = [];

    var _a = this.normalizeRelativeEntries(),
        orphanedRelativeEntries = _a[0],
        anchors = _a[1];

    var entryList = tslib_1.__spreadArrays(this.absoluteEntries, orphanedRelativeEntries);

    entryList = this.sort(entryList);

    for (var _i = 0, entryList_1 = entryList; _i < entryList_1.length; _i++) {
      var entry = entryList_1[_i];
      var defaultAnchorValue = {
        prev: undefined,
        next: undefined
      };

      var _b = entry.name ? anchors[entry.name] || defaultAnchorValue : defaultAnchorValue,
          prev = _b.prev,
          next = _b.next;

      var relativeEntry = prev; //reverse relative entry linked list and add to ordered handler list

      while (relativeEntry === null || relativeEntry === void 0 ? void 0 : relativeEntry.prev) {
        relativeEntry = relativeEntry.prev;
      }

      while (relativeEntry) {
        middlewareList.push(relativeEntry.middleware);
        relativeEntry = relativeEntry.next;
      }

      middlewareList.push(entry.middleware);
      var orphanedEntry = entry;

      while (orphanedEntry.next) {
        middlewareList.push(orphanedEntry.next.middleware);
        orphanedEntry = orphanedEntry.next;
      }

      relativeEntry = next;

      while (relativeEntry) {
        middlewareList.push(relativeEntry.middleware);
        relativeEntry = relativeEntry.next;
      }
    }

    return middlewareList.reverse();
  };

  MiddlewareStack.prototype.resolve = function (handler, context) {
    for (var _i = 0, _a = this.getMiddlewareList(); _i < _a.length; _i++) {
      var middleware = _a[_i];
      handler = middleware(handler, context);
    }

    return handler;
  };

  return MiddlewareStack;
}();

exports.MiddlewareStack = MiddlewareStack;
var stepWeights = {
  initialize: 5,
  serialize: 4,
  build: 3,
  finalizeRequest: 2,
  deserialize: 1
};
var priorityWeights = {
  high: 3,
  normal: 2,
  low: 1
};